import { render } from "./ErrorResult.vue?vue&type=template&id=1770060a&scoped=true&lang=html"
import script from "./ErrorResult.vue?vue&type=script&lang=js"
export * from "./ErrorResult.vue?vue&type=script&lang=js"

import "./ErrorResult.vue?vue&type=style&index=0&id=1770060a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1770060a"]])

export default __exports__